export default "__VITE_ASSET__e9S4RABO__"